import { Fragment } from 'react'
import isFunction from 'lodash-es/isFunction'

import { isValueFunctionType } from './common'

export function isComponentReactFragment(Component) {
  return Component === Fragment
}

/**
 * @param {React.RefObject | React.RefCallback | null | undefined} ref
 * @param {*} value
 */
export function setRef(ref, value) {
  if (isValueFunctionType(ref)) {
    ref(value)
  } else if (ref) {
    ref.current = value
  }
}

/**
 * @template {*} TValue
 *
 * @param {React.SetStateAction<TValue>} nextValue
 * @param {TValue} currValue
 *
 * @returns {TValue}
 */
export function updateStateValue(nextValue, currValue) {
  return isFunction(nextValue) ? nextValue(currValue) : nextValue
}

/**
 * @template {*} TValue
 *
 * @param {TValue} value
 * @param {React.Dispatch<TValue>[]} actions
 *
 * @return {TValue}
 */
export function dipatch(value, ...actions) {
  actions.forEach(action => action(value))

  return value
}

/**
 * @template {*} TValue
 *
 * @param {React.Dispatch<React.SetStateAction<TValue>>} setState
 * @param {*} state
 * @param {React.Dispatch<TValue>[]} actions
 */
export function setStateAndDispatch(setState, state, ...actions) {
  let nextState

  setState(currState => {
    nextState = updateStateValue(state, currState)

    return nextState
  })

  dipatch(nextState, ...actions)
}
